/**
 * Areej storefront — bilingual toggle, PDP back, qty total, catalog nav.
 */
(function () {
  const STORAGE_LANG = "areej-lang";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  let productNames = null;
  let productContent = null;

  function localeFromPath() {
    const p = window.location.pathname;
    if (/\/en(\/|$)/.test(p)) return "en";
    if (/\/ar(\/|$)/.test(p)) return "ar";
    return null;
  }

  function currentLang() {
    try {
      const stored = localStorage.getItem(STORAGE_LANG);
      if (stored === "en" || stored === "ar") return stored;
    } catch (_) {}
    return localeFromPath() || "ar";
  }

  function lookupProductName(handle) {
    if (!productNames || !handle) return null;
    if (productNames[handle]) return productNames[handle];
    try {
      const decoded = decodeURIComponent(handle);
      if (productNames[decoded]) return productNames[decoded];
    } catch (_) {}
    return null;
  }

  function applyProductNames(lang) {
    if (!productNames) return;
    const isEn = lang === "en";
    $$(".areej-product-name").forEach((el) => {
      const handle = el.closest("[data-product-handle]")?.dataset.productHandle;
      const entry = lookupProductName(handle);
      if (entry) {
        el.setAttribute("data-ar", entry.ar);
        el.setAttribute("data-en", entry.en);
        el.textContent = isEn ? entry.en : entry.ar;
      } else {
        const ar = el.getAttribute("data-ar");
        const en = el.getAttribute("data-en");
        if (ar) el.textContent = isEn && en ? en : ar;
      }
    });
  }

  function productHandle() {
    const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function productDescBlocks() {
    return $$(".product-details .rte");
  }

  function applyDescriptionBlocks(lang, descBlocks, entry) {
    if (!descBlocks.length) return;
    const isEn = lang === "en";
    const seenText = new Set();
    descBlocks.forEach((descEl, i) => {
      let ar = entry?.description?.ar || descEl.getAttribute("data-ar") || "";
      let en = entry?.description?.en || descEl.getAttribute("data-en") || "";

      if (!ar && !en) {
        const raw = (descEl.textContent || "").trim();
        if (!raw) return;
        if (/[\u0600-\u06FF]/.test(raw)) ar = raw;
        else en = raw;
      }

      if (!ar && !en) return;

      descEl.setAttribute("data-ar", ar || en);
      descEl.setAttribute("data-en", en || ar);
      const text = isEn && en ? en : ar || en;
      descEl.innerHTML = `<p>${text}</p>`;
      const dedupeKey = text.trim();
      if (i > 0 || (dedupeKey && seenText.has(dedupeKey))) {
        descEl.hidden = true;
      } else if (dedupeKey) {
        seenText.add(dedupeKey);
      }
    });
  }

  function applyProductPageContent(lang) {
    const handle = productHandle();
    if (!handle) return;
    const isEn = lang === "en";
    const nameEntry = lookupProductName(handle);

    const titleEl =
      $("#MainContent h1") ||
      $('[data-block-type="text"] h1') ||
      $(".product-details h1");
    if (titleEl && nameEntry) {
      titleEl.textContent = isEn ? nameEntry.en : nameEntry.ar;
      titleEl.setAttribute("data-ar", nameEntry.ar);
      titleEl.setAttribute("data-en", nameEntry.en);
    }

    const descBlocks = productDescBlocks();
    const entry = productContent?.[handle];
    applyDescriptionBlocks(lang, descBlocks, entry);
  }

  function applyLang(lang) {
    const isEn = lang === "en";
    document.documentElement.lang = isEn ? "en" : "ar";
    document.documentElement.dir = isEn ? "ltr" : "rtl";
    $$("[data-ar]").forEach((el) => {
      if (el.classList.contains("areej-product-name")) return;
      const ar = el.getAttribute("data-ar");
      const en = el.getAttribute("data-en");
      if (!ar) return;
      if (el.classList.contains("rte") && el.hasAttribute("data-en")) {
        el.innerHTML = `<p>${isEn && en ? en : ar}</p>`;
        return;
      }
      el.textContent = isEn && en ? en : ar;
    });
    $$("[data-ar-placeholder]").forEach((el) => {
      const ar = el.getAttribute("data-ar-placeholder");
      const en = el.getAttribute("data-en-placeholder");
      if (ar) el.setAttribute("placeholder", isEn && en ? en : ar);
    });
    applyProductNames(lang);
    applyProductPageContent(lang);
    applyShopifyUi(lang);
    updateQtyTotal();
    const btn = $("#areej-lang-btn");
    if (btn) btn.textContent = isEn ? "عربي" : "EN";
    try {
      localStorage.setItem(STORAGE_LANG, lang);
    } catch (_) {}
  }

  const UI_ORIGINAL = new WeakMap();

  const UI_EXACT = {
    "Add to cart": "أضف للسلة",
    "Adding...": "جاري الإضافة...",
    "Added to cart": "تمت الإضافة",
    "Add to Cart": "أضف للسلة",
    "Buy it now": "اشترِ الآن",
    "Sold out": "نفذت الكمية",
    "Unavailable": "غير متوفر",
    "Size": "الحجم",
    "Quantity": "الكمية",
    "Cart": "السلة",
    "Search": "بحث",
    "Account": "حسابي",
    "From": "من",
    "Total": "المجموع",
    "Subtotal": "المجموع الفرعي",
    "Checkout": "إتمام الطلب",
    "View cart": "عرض السلة",
    "Your cart": "سلتك",
    "Your cart is empty": "سلتك فارغة",
    "in cart": "في السلة",
    "Quick add to cart bar": "إضافة سريعة للسلة",
    "Estimated total": "المجموع التقريبي",
    "Close": "إغلاق",
    "Menu": "القائمة",
    "Back": "رجوع",
    "Default Title": "الافتراضي",
    "Color": "اللون",
    "Title": "النوع",
  };

  const UI_REGEX = [
    [/^1\/4\s*Tola$/i, "ربع تولة"],
    [/^1\/2\s*Tola$/i, "نصف تولة"],
    [/^(\d+)\s*Tolas?$/i, (_, n) => `${n} تولات`],
    [/^Tola$/i, "تولة"],
    [/^tola$/i, "تولة"],
    [/^(\d+)Tolas?$/i, (_, n) => `${n} تولات`],
    [/^(\d+)Tolas?$/i, (_, n) => `${n} تولات`],
    [/^(\d+)\s*\/\s*(\d+)\s*Tola$/i, (_, a, b) => `${a}/${b} تولة`],
  ];

  function translateUiString(text, isEn) {
    const trimmed = text.trim();
    if (!trimmed) return text;
    if (isEn) {
      for (const [en, ar] of Object.entries(UI_EXACT)) {
        if (trimmed === ar) return en;
      }
      return text;
    }
    if (UI_EXACT[trimmed]) return UI_EXACT[trimmed];
    for (const [re, repl] of UI_REGEX) {
      const m = trimmed.match(re);
      if (m) return typeof repl === "function" ? repl(...m) : repl;
    }
    return text;
  }

  function applyShopifyUi(lang) {
    const isEn = lang === "en";
    const roots = [$("#MainContent"), $("#header-group"), $(".cart-drawer")].filter(Boolean);
    const skipTags = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"]);

    roots.forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const parent = node.parentElement;
        if (!parent || skipTags.has(parent.tagName)) continue;
        if (parent.closest("#areej-lang-btn")) continue;
        const raw = node.textContent;
        if (!raw || !raw.trim()) continue;
        if (!UI_ORIGINAL.has(node)) UI_ORIGINAL.set(node, raw);
        const original = UI_ORIGINAL.get(node);
        const trimmed = original.trim();
        const next = isEn ? trimmed : translateUiString(trimmed, false);
        if (raw.trim() !== next) {
          node.textContent = raw.replace(raw.trim(), next);
        }
      }
    });

    $$("[aria-label]").forEach((el) => {
      if (el.id === "areej-lang-btn") return;
      if (!UI_ORIGINAL.has(el)) UI_ORIGINAL.set(el, el.getAttribute("aria-label") || "");
      const original = String(UI_ORIGINAL.get(el)).trim();
      el.setAttribute("aria-label", isEn ? original : translateUiString(original, false));
    });
  }

  function isUrgentUiMutation(mutations) {
    if (currentLang() !== "ar") return false;
    return mutations.some((m) => {
      const el = m.target instanceof Element ? m.target : m.target.parentElement;
      return el?.closest?.(
        "variant-picker, .buy-buttons-block, add-to-cart-component, product-form-component",
      );
    });
  }

  function watchShopifyUi() {
    const root = $("#MainContent");
    if (!root || root.dataset.areejUiWatched) return;
    root.dataset.areejUiWatched = "1";
    let t;
    new MutationObserver((mutations) => {
      if (isUrgentUiMutation(mutations)) {
        clearTimeout(t);
        applyShopifyUi("ar");
        return;
      }
      clearTimeout(t);
      t = setTimeout(() => applyShopifyUi(currentLang()), 60);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function initVariantUiSync() {
    if (document.documentElement.dataset.areejVariantUiSync) return;
    document.documentElement.dataset.areejVariantUiSync = "1";
    const sync = () => {
      if (currentLang() === "ar") applyShopifyUi("ar");
    };
    document.addEventListener("variant:selected", sync);
    document.addEventListener("variant:update", sync);
  }

  async function loadJson(url) {
    if (!url) return null;
    try {
      const res = await fetch(url);
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  async function initProductData() {
    productNames = window.__AREEJ_NAMES || productNames || (await loadJson(window.__AREEJ_NAMES_URL));
    productContent =
      window.__AREEJ_CONTENT || productContent || (await loadJson(window.__AREEJ_CONTENT_URL));
    applyProductNames(currentLang());
    applyProductPageContent(currentLang());
  }

  function ensureLangButton() {
    let btn = $("#areej-lang-btn");
    const actions = document.querySelector("header-actions");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.id = "areej-lang-btn";
      btn.className = "header-actions__action button-unstyled areej-lang-link";
      btn.setAttribute("aria-label", "Toggle language");
      if (actions) actions.appendChild(btn);
      else document.body.appendChild(btn);
    } else {
      btn.classList.add("button-unstyled", "areej-lang-link");
      if (actions && btn.parentElement !== actions) actions.appendChild(btn);
    }
    btn.hidden = false;
    btn.textContent = currentLang() === "en" ? "عربي" : "EN";
    if (!btn.dataset.areejBound) {
      btn.dataset.areejBound = "1";
      btn.addEventListener("click", () => {
        const next = document.documentElement.lang === "en" ? "ar" : "en";
        applyLang(next);
      });
    }
  }

  function initLang() {
    productNames = window.__AREEJ_NAMES || productNames;
    productContent = window.__AREEJ_CONTENT || productContent;
    ensureLangButton();
    applyLang(currentLang());
    initProductData();
  }

  /** Keep Shopify locale out of URLs — language is client-side only */
  function stripLocalePath(pathname) {
    return pathname.replace(/^\/(en-kw|ar-kw|en|ar)(?=\/|$)/, "") || "/";
  }

  function initLocaleFreeLinks() {
    document.addEventListener(
      "click",
      (e) => {
        const a = e.target.closest("a[href]");
        if (!a || a.target === "_blank" || a.hasAttribute("download")) return;
        const href = a.getAttribute("href");
        if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:"))
          return;
        try {
          const url = new URL(href, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const stripped = stripLocalePath(url.pathname);
          if (stripped !== url.pathname) {
            e.preventDefault();
            url.pathname = stripped;
            window.location.assign(url.pathname + url.search + url.hash);
          }
        } catch (_) {}
      },
      true,
    );
  }

  function applyRecommendationBlocks(lang) {
    const isEn = lang === "en";
    $$(".areej-pdp-recommendations__header [data-ar]").forEach((el) => {
      const ar = el.getAttribute("data-ar");
      const en = el.getAttribute("data-en");
      if (ar) el.textContent = isEn && en ? en : ar;
    });
  }

  function watchDynamicContent() {
    document.querySelectorAll("product-recommendations").forEach((el) => {
      if (el.dataset.areejWatched) return;
      el.dataset.areejWatched = "1";
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => {
          applyProductNames(currentLang());
          applyRecommendationBlocks(currentLang());
        }, 80);
      }).observe(el, { childList: true, subtree: true });
    });
  }

  function initPageLifecycle() {
    window.addEventListener("pagereveal", () => {
      setTimeout(() => {
        initLang();
        initBackButton();
        initQtyTotal();
        initBrandWatermark();
        watchDynamicContent();
        watchShopifyUi();
        initVariantUiSync();
        applyShopifyUi(currentLang());
      }, 0);
    });
  }

  /* ── Scroll nav ── */
  function initScrollNav() {
    const links = $$(".areej-scroll-nav__link");
    const sections = $$(".areej-band[data-scroll-cat], [data-scroll-cat]");
    if (!links.length) return;

    function navTarget(link) {
      const href = link.getAttribute("href") || "";
      if (!href) return null;
      if (href.startsWith("#")) return { kind: "hash", id: href.slice(1) };
      try {
        const url = new URL(href, window.location.origin);
        const path = stripLocalePath(url.pathname);
        const view = url.searchParams.get("view");
        if (view) return { kind: "view", view };
        if (path.startsWith("/collections/")) return { kind: "collection", path };
        const hash = url.hash.startsWith("#") ? url.hash.slice(1) : "";
        if (hash) return { kind: "hash", id: hash };
        return { kind: "path", path: path + url.search };
      } catch (_) {
        return null;
      }
    }

    function pageTarget() {
      const path = stripLocalePath(window.location.pathname);
      const view = new URLSearchParams(window.location.search).get("view");
      if (view) return { kind: "view", view };
      if (path.startsWith("/collections/")) return { kind: "collection", path };
      const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "";
      if (hash && document.getElementById(hash)) return { kind: "hash", id: hash };
      return { kind: "path", path: path + window.location.search };
    }

    function targetsMatch(a, b) {
      if (!a || !b || a.kind !== b.kind) return false;
      if (a.kind === "view") return a.view === b.view;
      if (a.kind === "collection") return a.path === b.path;
      if (a.kind === "hash") return a.id === b.id;
      return a.path === b.path;
    }

    function markActiveFromPage() {
      const here = pageTarget();
      links.forEach((link) => {
        link.classList.toggle("is-active", targetsMatch(navTarget(link), here));
      });
    }

    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        const t = navTarget(link);
        if (t?.kind === "hash" && t.id) {
          const target = document.getElementById(t.id);
          const path = stripLocalePath(window.location.pathname);
          const onCatalog = path === "/pages/catalog" || path.endsWith("/pages/catalog");
          const href = link.getAttribute("href") || "";
          if (target && (href.startsWith("#") || onCatalog)) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            history.replaceState(null, "", `${path}#${t.id}`);
            links.forEach((l) => {
              l.classList.toggle("is-active", targetsMatch(navTarget(l), t));
            });
          }
        }
      });
    });

    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }

    markActiveFromPage();

    if (!sections.length || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.id;
          const t = { kind: "hash", id };
          links.forEach((l) => {
            l.classList.toggle("is-active", targetsMatch(navTarget(l), t));
          });
        });
      },
      { rootMargin: "-30% 0px -55% 0px", threshold: 0 },
    );
    sections.forEach((s) => observer.observe(s));
  }

  /* ── Back button (PDP + catalog menu pages) ── */
  function catalogPageKind() {
    const path = stripLocalePath(window.location.pathname);
    if (path === "/pages/catalog" || path.endsWith("/pages/catalog")) return "all";
    if (path.startsWith("/pages/catalog-")) return "category";
    return null;
  }

  function backButtonFallback(ctx) {
    if (ctx === "pdp" || ctx === "category") return "/pages/catalog";
    return "/";
  }

  function initBackButton() {
    if ($("#areej-back-btn")) return;
    const ctx = productHandle() ? "pdp" : catalogPageKind();
    if (!ctx) return;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.id = "areej-back-btn";
    btn.setAttribute("aria-label", "Back");
    btn.innerHTML =
      document.documentElement.dir === "ltr"
        ? "&#8592;"
        : "&#8594;";
    btn.addEventListener("click", () => {
      if (window.history.length > 1) window.history.back();
      else window.location.href = backButtonFallback(ctx);
    });
    document.body.appendChild(btn);
  }

  /* ── Qty × price total (Keeta-style) ── */
  function parseUnitPrice() {
    const priceEl =
      $("product-price") ||
      $(".product-details product-price") ||
      $('[ref="priceContainer"]') ||
      $(".price");
    if (!priceEl) return 0;
    const text = priceEl.textContent || "";
    const m = text.replace(/,/g, "").match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function updateQtyTotal() {
    const qtyInput = $('input[name="quantity"]');
    const wrapper = $(".quantity-selector-wrapper");
    if (!qtyInput || !wrapper) return;

    let totalEl = $("#areej-qty-total");
    if (!totalEl) {
      totalEl = document.createElement("div");
      totalEl.id = "areej-qty-total";
      totalEl.className = "areej-qty-total";
      wrapper.parentElement?.insertBefore(totalEl, wrapper.nextSibling);
    }

    const qty = parseInt(qtyInput.value || "1", 10) || 1;
    const unit = parseUnitPrice();
    if (qty <= 1 || !unit) {
      totalEl.hidden = true;
      return;
    }
    totalEl.hidden = false;
    const total = (unit * qty).toFixed(3);
    const isEn = document.documentElement.lang === "en";
    totalEl.textContent = isEn ? `Total: ${total} KD` : `المجموع: ${total} د.ك`;
  }

  function initQtyTotal() {
    const qtyInput = $('input[name="quantity"]');
    if (!qtyInput) return;

    qtyInput.addEventListener("input", updateQtyTotal);
    qtyInput.addEventListener("change", updateQtyTotal);
    $(".quantity-selector")?.querySelectorAll("button").forEach((b) => {
      b.addEventListener("click", () => setTimeout(updateQtyTotal, 80));
    });
    document.addEventListener("variant:update", updateQtyTotal);
    document.addEventListener("VariantUpdateEvent", updateQtyTotal);
    setTimeout(updateQtyTotal, 300);
  }

  /* ── Brand watermark on product media ── */
  function initBrandWatermark() {
    if (!productHandle()) return;
    $$(".product-media-container, .media-gallery, .product-media").forEach((el) => {
      if (el.classList.contains("areej-watermarked")) return;
      el.classList.add("areej-watermarked");
    });
  }

  function initAnchors() {
    $$('a[href="#areej-cat-bestsellers"]').forEach((a) => {
      a.addEventListener("click", (e) => {
        const target = document.getElementById("areej-cat-bestsellers");
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }

  function initLeadModal() {
    const modal = document.getElementById("areej-lead-modal");
    if (!modal) return;

    const STORAGE_KEY = modal.dataset.storageKey || "areej-lead-submitted";
    const DISMISS_KEY = modal.dataset.dismissKey || "areej-lead-dismissed";
    const SFS_TOKEN = modal.dataset.sfsToken || "";

    // Show only if not already submitted (1y) and not dismissed this session.
    let show = true;
    try {
      if (localStorage.getItem(STORAGE_KEY)) show = false;
      if (sessionStorage.getItem(DISMISS_KEY)) show = false;
    } catch (_) {}
    if (!show) return;

    // Delay slightly so page renders first.
    setTimeout(() => {
      modal.hidden = false;
      document.body.style.overflow = "hidden";
      const phoneInput = modal.querySelector("#areej-lead-phone");
      if (phoneInput) phoneInput.focus();
    }, 800);

    function close() {
      modal.hidden = true;
      document.body.style.overflow = "";
      try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch (_) {}
    }

    modal.querySelectorAll("[data-lead-close]").forEach((el) => {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) close();
    });

    const form = modal.querySelector("#areej-lead-form");
    const errEl = modal.querySelector("[data-lead-error]");
    const submitBtn = form ? form.querySelector('button[type="submit"]') : null;

    function setError(msg) {
      if (!errEl) return;
      if (msg) {
        errEl.textContent = msg;
        errEl.hidden = false;
      } else {
        errEl.hidden = true;
      }
    }

    function normalizePhone(raw) {
      const digits = (raw || "").replace(/\D/g, "");
      // Kuwaiti local: 5XXXXXXX (8 digits) → +9655XXXXXXX
      if (digits.length === 8 && digits[0] === "5") return "+965" + digits;
      if (digits.length === 11 && digits.startsWith("9655")) return "+" + digits;
      if (digits.length === 12 && digits.startsWith("9655")) return "+" + digits.slice(0, 11);
      return null;
    }

    function showSuccess() {
      const card = modal.querySelector(".areej-lead-modal__card");
      if (!card) return;
      const isEn = currentLang() === "en";
      card.innerHTML = `
        <div class="areej-lead-modal__success">
          <p class="areej-eyebrow">${isEn ? "Done" : "تم"}</p>
          <h3>${isEn ? "You're in 🎉" : "سجّلناك 🎉"}</h3>
          <div class="areej-gold-line areej-gold-line--center"></div>
          <p>${isEn ? "We'll WhatsApp you our timed offers and new arrivals." : "بنتوصل واتساب بكل عروضنا المؤقتة وأحدث منتجاتنا."}</p>
        </div>
      `;
      setTimeout(() => {
        modal.hidden = true;
        document.body.style.overflow = "";
      }, 2200);
    }

    async function saveToCart(phone) {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: { lead_phone: phone, lead_source: "areej-popup" },
            note: "Site lead — phone: " + phone,
          }),
        });
      } catch (_) {}
    }

    async function saveToStorefront(phone) {
      if (!SFS_TOKEN) return false;
      const store = (window.Shopify && window.Shopify.shop) || "";
      if (!store) return false;
      // Generate stable placeholder email from phone so Shopify accepts the customer.
      // Customer can update later via account UI. With new-customer-accounts + phone login,
      // phone is the primary identifier.
      const placeholder = "whatsapp+" + phone.replace(/\D/g, "") + "@areej.leads";
      const password = "Arj" + Math.random().toString(36).slice(2, 12) + "!1";
      const query = `
        mutation customerCreate($input: CustomerCreateInput!) {
          customerCreate(input: $input) {
            customer { id phone }
            customerUserErrors { field message code }
          }
        }`;
      try {
        const res = await fetch(
          "https://" + store + "/api/2025-01/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": SFS_TOKEN,
            },
            body: JSON.stringify({
              query,
              variables: {
                input: {
                  phone: phone,
                  email: placeholder,
                  password: password,
                  acceptsMarketing: true,
                },
              },
            }),
          }
        );
        const data = await res.json();
        const errs = data?.data?.customerCreate?.customerUserErrors || [];
        if (errs.length === 0) return true;
        // If "already taken" → customer exists with that email/phone. That's fine.
        const taken = errs.some((e) =>
          /taken|already/i.test(e.message || "") || e.code === "TAKEN"
        );
        return taken;
      } catch (_) {
        return false;
      }
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const raw = form.querySelector("#areej-lead-phone").value;
      const phone = normalizePhone(raw);
      if (!phone) {
        setError(currentLang() === "en"
          ? "Enter a valid Kuwaiti number (5XXX XXXX)"
          : "اكتب رقم كويتي صحيح (5XXX XXXX)");
        return;
      }
      setError("");
      if (submitBtn) submitBtn.disabled = true;
      // Save to cart (always — visible in Admin > Carts/Orders)
      await saveToCart(phone);
      // Try real Customer record (optional — needs Storefront token)
      try { await saveToStorefront(phone); } catch (_) {}
      try { localStorage.setItem(STORAGE_KEY, phone); } catch (_) {}
      if (submitBtn) submitBtn.disabled = false;
      showSuccess();
    });
  }

  function initTimedOffers() {
    document.querySelectorAll("[data-timed-section]").forEach((section) => {
      const deadlineAttr = section.dataset.deadline;
      if (!deadlineAttr) return;
      const cd = section.querySelector("[data-countdown]");
      if (!cd) return;
      const endedEl = section.querySelector("[data-ended]");
      // Parse as Kuwait time (UTC+3)
      const deadline = new Date(deadlineAttr.replace(" ", "T") + ":00+03:00");
      if (isNaN(deadline.getTime())) return;

      const dEl = cd.querySelector("[data-cd-days]");
      const hEl = cd.querySelector("[data-cd-hours]");
      const mEl = cd.querySelector("[data-cd-mins]");
      const sEl = cd.querySelector("[data-cd-secs]");
      const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

      function tick() {
        const now = new Date();
        const diff = deadline - now;
        if (diff <= 0) {
          dEl.textContent = "00"; hEl.textContent = "00";
          mEl.textContent = "00"; sEl.textContent = "00";
          cd.hidden = true;
          if (endedEl) endedEl.hidden = false;
          section.dataset.ended = "true";
          clearInterval(timer);
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        dEl.textContent = pad(d);
        hEl.textContent = pad(h);
        mEl.textContent = pad(m);
        sEl.textContent = pad(s);
      }
      tick();
      const timer = setInterval(tick, 1000);
    });
  }

  function boot() {
    initLocaleFreeLinks();
    initPageLifecycle();
    initLang();
    initScrollNav();
    initBackButton();
    initQtyTotal();
    initBrandWatermark();
    initAnchors();
    initLeadModal();
    initTimedOffers();
    watchDynamicContent();
    watchShopifyUi();
    initVariantUiSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
